export default __webpack_public_path__ + "static/media/login.da80012f.svg";